/* ============================================================
   ZARUBA — Search page: recent searches (localStorage) + clear
   ============================================================ */
(function () {
  const KEY = 'zaruba:recent-searches';
  const MAX = 6;

  function read() {
    try {
      return JSON.parse(localStorage.getItem(KEY)) || [];
    } catch (e) {
      return [];
    }
  }

  function write(list) {
    try {
      localStorage.setItem(KEY, JSON.stringify(list));
    } catch (e) {
      /* storage unavailable — ignore */
    }
  }

  function add(term) {
    term = (term || '').trim();
    if (!term) return read();
    let list = read().filter((t) => t.toLowerCase() !== term.toLowerCase());
    list.unshift(term);
    list = list.slice(0, MAX);
    write(list);
    return list;
  }

  function remove(term) {
    const list = read().filter((t) => t !== term);
    write(list);
    return list;
  }

  function escapeHtml(s) {
    return String(s).replace(
      /[&<>"']/g,
      (c) => ({ '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;', "'": '&#39;' }[c])
    );
  }

  class ZarubaSearch {
    constructor(root) {
      this.root = root;
      this.searchUrl = root.dataset.searchUrl || '/search';
      this.panel = root.querySelector('[data-recent-panel]');
      this.list = root.querySelector('[data-recent]');
      this.input = root.querySelector('[data-search-input]');
      this.clearBtn = root.querySelector('[data-search-clear]');

      const terms = (root.dataset.searchTerms || '').trim();
      let recents = read();
      if (terms) recents = add(terms);
      this.renderRecent(recents);

      if (this.clearBtn) {
        this.clearBtn.addEventListener('click', () => {
          if (this.input) {
            this.input.value = '';
            this.input.focus();
            this.clearBtn.hidden = true;
          }
        });
      }

      if (this.input) {
        this.input.addEventListener('input', () => {
          if (this.clearBtn) this.clearBtn.hidden = this.input.value.trim() === '';
        });
      }

      if (this.list) {
        this.list.addEventListener('click', (e) => {
          const btn = e.target.closest('[data-recent-remove]');
          if (!btn) return;
          e.preventDefault();
          this.renderRecent(remove(btn.dataset.term));
        });
      }
    }

    renderRecent(list) {
      if (!this.list || !this.panel) return;
      if (!list.length) {
        this.panel.hidden = true;
        this.list.innerHTML = '';
        return;
      }
      this.panel.hidden = false;
      this.list.innerHTML = list
        .map((term) => {
          const safe = escapeHtml(term);
          const href = this.searchUrl + '?q=' + encodeURIComponent(term) + '&type=product';
          return (
            '<li class="zaruba-search__recent-item">' +
            '<a class="zaruba-search__recent-link" href="' +
            href +
            '">' +
            safe +
            '</a>' +
            '<button type="button" class="zaruba-search__recent-remove" data-recent-remove data-term="' +
            safe +
            '" aria-label="Remove">×</button>' +
            '</li>'
          );
        })
        .join('');
    }
  }

  function init() {
    document.querySelectorAll('[data-zaruba-search]').forEach((root) => {
      if (root.dataset.zInit === 'true') return;
      root.dataset.zInit = 'true';
      new ZarubaSearch(root);
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
  document.addEventListener('shopify:section:load', init);
})();
